import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/**
 * A "See more" link component
 * @param {object} props The component props
 * @param {string} props.url The url to link to
 * @returns {React.ReactElement} The See more link component
 */
export default function SeeMoreLink({ url }) {
  const { t } = useTranslation();
  return (
    <Link to={url} className="text-primary">
      {t("seeMore")}
    </Link>
  );
}
